export const normalizeSexOnBirthValue = (
  value,
  { allowEmptyString = false } = {},
) => {
  if (value === "" || value === null || value === undefined) {
    return allowEmptyString && value === "" ? "" : null;
  }

  const normalizedValue = Number(value);
  return normalizedValue === 0 || normalizedValue === 1
    ? String(normalizedValue)
    : null;
};

export const isValidSexOnBirthValue = (value) =>
  value === "" || normalizeSexOnBirthValue(value) !== null;
